import { Modal } from '@/components/Modal'

interface VirtualTourModalProps {
	open: boolean
	onClose: () => void
	title: string
	url?: string
}

export function VirtualTourModal ({
	open,
	onClose,
	title,
	url
}: VirtualTourModalProps) {
	const modalTitle = title ? `${title} – 360 Tour` : '360 Tour'

	return (
		<Modal
			open={open}
			onClose={onClose}
			title={modalTitle}
			fullScreen
			spacesClass='spaces-tour-modal'
		>
			{/* Older iOS WebKit won't clip an iframe to an ancestor's border-radius; redundant where it does. */}
			<div className='spaces:relative spaces:flex spaces:items-center spaces:justify-center spaces:w-full spaces:h-full spaces:bg-canvas-4 spaces:rounded-b-24'>
				{url
					? (
						<iframe
							src={url}
							title={modalTitle}
							className='spaces:w-full spaces:h-full spaces:border-0 spaces:rounded-b-24'
							allow='autoplay; fullscreen'
						/>
					)
					: (
						<p className='spaces:text-14/16 spaces:font-default spaces:text-content-1 spaces:text-center spaces:max-w-[800px]'>
							[ 360 Tour Embedded Here – No UI ]
						</p>
					)}
			</div>
		</Modal>
	)
}
